module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Understanding",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60,55 C55.127024,55 13.3021113,55 10,55 C10,43.8366699 14.1764427,34.2923521 24.1662077,30.4365191 C23.1158447,29.284668 20.0156657,25.7830811 20.0156657,20.0223796 C20.0156657,13.3143916 25.6017125,5 35,5 C43.7435452,5 49.9338786,12.3539225 49.9338786,20.0223796 C49.9338786,26.9734701 45.8765671,30 45.8765671,30.4549123 C55.8335853,34.3226378 60,43.8543791 60,55 Z M33.4026903,21.6563444 L35.8526991,21.6563444 L36.1169158,20.1467116 C38.7350625,19.6022539 40.8487956,18.3153539 40.8487956,15.1723481 L40.8487956,15.122852 C40.8487956,11.8313577 38.4948655,10 35.0360295,10 C32.4178829,10 30.5443467,11.0889154 29.1512044,12.6727923 L31.3610163,15.1723481 C32.4659222,14.0339366 33.6188676,13.4647308 34.9639705,13.4647308 C36.3571127,13.4647308 37.1737823,14.1081808 37.1737823,15.2218443 L37.1737823,15.2713404 C37.1737823,16.5829885 35.9968173,17.3996751 32.9703358,17.5234155 L32.8502374,17.6471558 L33.4026903,21.6563444 Z M32.6100404,27.5463867 L36.5012309,27.5463867 L36.5012309,23.5866944 L32.6100404,23.5866944 L32.6100404,27.5463867 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4dbb11e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/understanding.vue
// module id = 659
// module chunks = 1